<section class="input-number-range-container flex-col justify-between" [ngClass]="className" role="group" [formGroup]="inputNumberRangeForm">
    <mat-form-field appearance="outline" class="flex w-[180px]">
      <input class="w-16" (input)="handleOnChange()" [disabled]="getIsDisabled()" type="number" min="0" matInput i18n-placeholder [placeholder]="getFromPlaceholder()" formControlName="from"  [errorStateMatcher]="matcher">
      @if (icon) {
        <lib-app-icon [icon]="icon" matSuffix size="48x48" className="p-[12px]" />
      } @else {
        <lib-app-icon [icon]="'delete_icon'" matSuffix size="48x48" className="p-[12px]" (click)="handleOnFromReset()" />
      }
    </mat-form-field>
    
    <mat-form-field appearance="outline" class="flex w-[180px]">
      <input class="w-16" type="number" min="0" (input)="handleOnChange()" [disabled]="getIsDisabled()" matInput i18n-placeholder [placeholder]="getToPlaceholder()" formControlName="to" [errorStateMatcher]="matcher">
      @if (icon) {
        <lib-app-icon [icon]="icon" matSuffix size="48x48" className="p-[12px]" />
      } @else {
        <lib-app-icon [icon]="'delete_icon'" matSuffix size="48x48" className="p-[12px]" (click)="handleOnToReset()" />
      }
    </mat-form-field>
</section>
@if(this.inputNumberRangeForm && this.inputNumberRangeForm.hasError('invalidDateRange')) {
    <div class="flex mb-2">
      <mat-error i18n>
        From number should be smaller than to number.
      </mat-error>
    </div>
}